import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageContactLocations,
  DeleteContactLocations,
  EditContactLocations,
  GetContactLocations,
  SetPrimaryContactLocation,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";

const ContactLocations = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  
  const privilegeId = "10"; 
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  
  const Schema = Yup.object().shape({
    location_name: Yup.string().trim().required("Location name is required"),
    email: Yup.string().email("Invalid email format"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetContactLocations({
        callback: (response) => {
          const responseData = response?.data;
          
          if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
            setData([responseData]);
            setTotalData(1);
          } else if (isValidArray(responseData)) {
            setData(responseData);
            setTotalData(responseData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    
    if (array.length === 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "location_name",
          type: inputType.text,
          title: "Location Name",
          placeholder: "Enter location name",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "address",
          type: inputType.text,
          title: "Address",
          placeholder: "Enter address",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "city",
          type: inputType.text,
          title: "City",
          placeholder: "Enter city",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "country",
          type: inputType.text,
          title: "Country",
          placeholder: "Enter country",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "phone",
          type: inputType.text,
          title: "Phone",
          placeholder: "Enter phone",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "email",
          type: inputType.email,
          title: "Email",
          placeholder: "Enter email",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "map_url",
          type: inputType.text,
          title: "Map URL",
          placeholder: "Enter map URL",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "is_primary",
          type: inputType.checkbox,
          title: "Is Primary",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "display_order",
          type: inputType.number,
          title: "Display Order",
          placeholder: "Enter display order",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "is_active",
          type: inputType.checkbox,
          title: "Is Active",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "location_name" },
    { type: columntype.text, name: "address" },
    { type: columntype.text, name: "city" },
    { type: columntype.text, name: "country" },
    { type: columntype.text, name: "phone" },
    { type: columntype.text, name: "email" },
    { type: columntype.text, name: "map_url" },
    { type: columntype.boolean, name: "is_primary" },
    { type: columntype.text, name: "display_order" },
    { type: columntype.boolean, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location Name",
      withSort: false,
    },
    {
      id: "address",
      numeric: false,
      disablePadding: false,
      label: "Address",
      withSort: false,
    },
    {
      id: "city",
      numeric: false,
      disablePadding: false,
      label: "City",
      withSort: false,
    },
    {
      id: "country",
      numeric: false,
      disablePadding: false,
      label: "Country",
      withSort: false,
    },
    {
      id: "phone",
      numeric: false,
      disablePadding: false,
      label: "Phone",
      withSort: false,
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
      withSort: false,
    },
    {
      id: "map_url",
      numeric: false,
      disablePadding: false,
      label: "Map URL",
      withSort: false,
    },
    {
      id: "is_primary",
      numeric: false,
      disablePadding: false,
      label: "Is Primary",
      withSort: false,
    },
    {
      id: "display_order",
      numeric: false,
      disablePadding: false,
      label: "Display Order",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is Active",
      withSort: false,
    },
    (dataPrivileges[privilegeId]?.access_edit == 1 ||
      dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Actions",
      withSort: false,
    },
  ];
  
  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Delete ${row?.location_name ?? "this item"}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteContactLocations({
                      callback: () => GetData(),
                      id: [row?.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Set Primary",
      function: async (row) => {
        if (row) {
          dispatch(
            SetPrimaryContactLocation({
              callback: () => GetData(),
              id: row?.id,
            })
          );
        }
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditContactLocations({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
          GetData();
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => 
      prevData.map(item => 
        item.id === id ? {...item, [failedName]: newData} : item
      )
    );
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, type) => tableName && type && GetData({ tableName, type })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteContactLocations({
                      callback: () => GetData(),
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />
      
      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Contact Locations"}
          editMode={editMode}
          description={editMode ? "Edit Contact Location" : "Add New Contact Location"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(values) => {
            dispatch(
              ManageContactLocations({
                editMode,
                values,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      )}
    </>
  );
};

export default ContactLocations;

